import { useState } from "react";
import * as yup from "yup";
import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { Modal } from "@circle-react-uikit/ModalV2";
import { OtpChallengeFormContent } from "./FormContent";

const validationSchema = yup.object({
  otpCode: yup
    .string()
    .required(t("otp_challenge_modal.otp_required"))
    .matches(/^\d{6}$/, t("otp_challenge_modal.otp_invalid")),
});

interface FormData {
  otpCode: string;
}

interface OtpChallengeModalProps {
  error?: string | null;
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (otpCode: string) => void | Promise<void>;
}

export const OtpChallengeModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading = false,
  error,
}: OtpChallengeModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: FormData) => {
    setIsSubmitting(true);
    try {
      await onSubmit(data.otpCode);
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} className="!z-[2000]">
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{t("otp_challenge_modal.title")}</Modal.Title>
        </Modal.Header>

        <Form<FormData>
          validationSchema={validationSchema}
          defaultValues={{ otpCode: "" }}
          onSubmit={handleSubmit}
        >
          <OtpChallengeFormContent
            error={error}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            onClose={onClose}
          />
        </Form>
      </Modal.Content>
    </Modal>
  );
};

OtpChallengeModal.displayName = "OtpChallengeModal";
